<template>
  <el-form-item
    class="ny-form-item__checkbox"
    :class="{ 'is-required': required }"
    :label="label"
    :prop="prop"
  >
    <el-checkbox
      class="ny-form-item__checkall"
      :indeterminate="isIndeterminate"
      v-model="checkAll"
      :disabled="disabled"
      @change="handleCheckAllChange"
    >全选</el-checkbox>
    <el-checkbox-group
      class="ny-form-item__checkgroup is-multiple"
      :class="{ 'is-half': half }"
      v-model="currentValue"
      v-bind="$attrs"
      @change="handleCheckedGroupChange"
    >
      <el-checkbox
        v-for="item in data"
        :key="item[keyValue[1]]"
        :disabled="disabled"
        :label="item[keyValue[1]]"
      >{{item[keyValue[0]]}}</el-checkbox>
    </el-checkbox-group>
  </el-form-item>
</template>

<script>
export default {
  name: 'NyFormItemCheckbox',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    keyValue: {
      type: Array,
      default: () => ['name', 'value']
    },
    value: {
      required: true
    },
    data: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: Boolean,
    label: String,
    prop: String,
    half: Boolean
  },
  data () {
    const value = this.value || [];
    let checkedCount = value.length
    return {
      currentValue: value,
      isIndeterminate: checkedCount > 0 && checkedCount < this.data.length,
      checkAll: checkedCount === this.data.length && checkedCount > 0
    }
  },
  methods: {
    handleCheckAllChange (event) {
      this.currentValue = event ? this.data.map(v => v[this.keyValue[1]]) : []
      this.isIndeterminate = false
    },
    handleCheckedGroupChange (value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.data.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.data.length;
    }
  },
  watch: {
    value (newVal) {
      newVal = newVal || []
      this.currentValue = newVal;
      let checkedCount = newVal.length
      this.checkAll = checkedCount === this.data.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.data.length
    },
    currentValue (value) {
      this.$emit('input', value)
      this.$emit('change', value)
    }
  }
}
</script>

<style lang="scss">
@include b(ny-form-item) {
  @include e(checkbox) {
    .el-checkbox {
      width: 120px;
      margin-left: 16px;
    }

    @include e(checkall) {
      position: absolute;
      left: 16px;

      &.el-checkbox {
        margin-left: 0;
      }
    }

    @include e(checkgroup) {
      position: relative;

      .el-checkbox {
        &:first-child {
          margin-left: 136px;
        }
      }
    }
  }
}
</style>
